<template>
  <div class="q-mt-md game-content">
    <!-- Header Of the page -->
    <h3 class="text-bold q-m-md inline-block">
      {{ headerMessage }}
    </h3>

    <!-- Select all games with search by name -->
    <div class="row">
      <div class="col-6">
        <q-select
          v-model="selectedGame"
          use-input
          input-debounce="0"
          outlined
          clearable
          :disable="getPromoLoading"
          bg-color="white"
          :options="gamesListOptions"
          :option-label="'GameName'"
          @update:model-value="(val) => onSelectChange(val)"
          @filter="filterFn"
        />
      </div>

      <div
        class="col-6 flex justify-end"
        v-if="this.getUser.idTokenClaims.roles.includes('Admin')"
      >
        <q-toggle
          v-model="isAARP"
          :color="getEnv === 'stage' ? 'secondary' : 'primary'"
          :disable="getPromoLoading"
          left-label
          :label="!isAARP ? 'Arkadium User' : 'AARP User'"
        />
      </div>
    </div>

    <q-card
      class="q-mt-md card-container"
      v-show="!isAARP || (isAARP && selectedGame)"
    >
      <q-card-section v-if="getPromoLoading" class="loading-wrapper">
        <div>
          <q-spinner color="primary" size="3em" />
        </div>
      </q-card-section>
      <q-card-section class="q-pt-lg" v-else>
        <div class="row">
          <div class="col-6">
            <div class="flex">
              <q-input
                v-model="gameName"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                :label="isAARP ? 'Game Name' : 'GameName'"
                :readonly="isAARP"
                :rules="[
                  (val) => val.length >= 1 || 'Please Insert at least 1 char',
                ]"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-input
                v-model="uRLAlias"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                label="URLAlias"
                :readonly="isAARP"
                :rules="[
                  (val) => val.length >= 1 || 'Please Insert at least 1 char',
                ]"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-input
                v-model="arena5Slug"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                label="Arena5Slug"
                :rules="[
                  (val) => val.length >= 1 || 'Please Insert at least 1 char',
                ]"
              />
            </div>

            <div class="flex">
              <q-input
                v-model="finalURL"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                :readonly="isAARP && !isFakeGame"
                :label="isAARP ? 'Final URL' : 'FinalURL'"
                :rules="[
                  (val) => val.length >= 1 || 'Please Insert at least 1 char',
                ]"
              />
            </div>

            <div class="flex" v-show="!isAARP || (isAARP && !isFakeGame)">
              <q-input
                v-model="onPageTitle"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                :label="isAARP ? 'Page Title' : 'OnPageTitle'"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-input
                v-model="onPageTitleInnerHtml"
                style="width: 90%"
                class="q-ml-md q-mt-lg"
                outlined
                label="OnPageTitleInnerHtml"
              />
            </div>

            <div class="flex" v-show="!isAARP || (isAARP && !isFakeGame)">
              <q-input
                v-model="onPageDescription"
                style="width: 90%"
                class="q-ml-md q-mt-lg"
                outlined
                type="textarea"
                :label="isAARP ? 'Page Box Description' : 'OnPageDescription'"
                :rules="[
                  (val) => val.length >= 1 || 'Please Insert at least 1 char',
                ]"
              />
            </div>

            <div class="flex" v-show="!isAARP || (isAARP && !isFakeGame)">
              <q-input
                v-model="ogTitle"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                :label="isAARP ? 'Og: Title' : 'OgTitle'"
                :rules="[
                  (val) => val.length >= 1 || 'Please Insert at least 1 char',
                ]"
              />
            </div>

            <div class="flex" v-show="!isAARP || (isAARP && !isFakeGame)">
              <q-input
                v-model="ogDescription"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                type="textarea"
                :label="isAARP ? 'Og: Description' : 'OgDescription'"
                :rules="[
                  (val) => val.length >= 1 || 'Please Insert at least 1 char',
                ]"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-input
                v-model="adUnitCustom"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                label="adUnitCustom"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-input
                v-model="adUnitOverride"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                label="adUnitOverride"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-input
                v-model="canonicalTag"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                label="CanonicalTag"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-input
                v-model="challengePoints"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                label="ChallengePoints"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-select
                v-model="topPlayerScores"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                multiple
                use-input
                use-chips
                hide-dropdown-icon
                new-value-mode="add-unique"
                :options="[]"
                label="topPlayerScores"
              />
            </div>
          </div>

          <div class="col-6">
            <div v-show="!isAARP">
              <q-toggle
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                v-model="isHidden"
                label="isHidden"
              />
            </div>

            <div v-show="!isAARP">
              <q-toggle
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                v-model="isFakeGame"
                label="isFakeGame"
              />
            </div>

            <div class="" v-show="!isAARP">
              <q-toggle
                v-model="isInnerHtmlOnPageDescription"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                label="isInnerHtmlOnPageDescription"
              />
            </div>

            <div class="flex" v-show="!isAARP || (isAARP && !isFakeGame)">
              <q-toggle
                v-model="theaterMode"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                :disable="isAARP"
                :label="isAARP ? 'Theater Mode' : 'TheaterMode'"
              />
            </div>

            <div class="flex" v-show="!isAARP || (isAARP && !isFakeGame)">
              <q-toggle
                v-model="isSchemaEnable"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                :label="isAARP ? 'Schema Enabled' : 'IsSchemaEnable'"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-toggle
                v-model="preventGameEndOnSavedScore"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                label="PreventGameEndOnSavedScore"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-toggle
                v-model="isRewardInModal"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                label="isRewardInModal"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-toggle
                v-model="isSupportRewardVideo"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                label="isSupportRewardVideo"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-toggle
                v-model="isScreenshot"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                label="isScreenshot"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-toggle
                v-model="isFriendGame"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                label="isFriendGame"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-toggle
                v-model="isChallengeGame"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                label="IsChallengeGame"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-toggle
                v-model="hideLeaderboard"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                label="HideLeaderboard"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-toggle
                v-model="devOnly"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                label="devOnly"
              />
            </div>

            <div class="flex" v-show="!isAARP || (isAARP && !isFakeGame)">
              <q-input
                v-model="promoDescription"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                type="textarea"
                :label="isAARP ? 'Promotion Description' : 'PromoDescription'"
                :rules="[
                  (val) => val.length >= 1 || 'Please Insert at least 1 char',
                ]"
              />
            </div>

            <div class="flex" v-show="!isAARP || (isAARP && !isFakeGame)">
              <q-input
                v-model="metaHTMLTitle"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                :label="isAARP ? 'Meta Title' : 'MetaHTMLTitle'"
                :rules="[
                  (val) => val.length >= 1 || 'Please Insert at least 1 char',
                ]"
              />
            </div>

            <div class="flex" v-show="!isAARP || (isAARP && !isFakeGame)">
              <q-input
                v-model="metaHTMLDescription"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                type="textarea"
                :label="isAARP ? 'Meta Description' : 'MetaHTMLDescription'"
                :rules="[
                  (val) => val.length >= 1 || 'Please Insert at least 1 char',
                ]"
              />
            </div>

            <!-- TODO: Remove condition so aarp can change it after task for modal is done -->
            <div class="flex" v-show="!isAARP">
              <q-toggle
                v-model="isLoginToPlay"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                :label="isAARP ? 'Login-Only To Play Mode' : 'isLoginToPlay'"
              />
            </div>

            <div class="flex" v-show="isLoginToPlay">
              <q-input
                v-model="loginToPlayTitle"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                :label="isAARP ? 'Login-Only Modal Title' : 'loginToPlayTitle'"
              />
            </div>

            <div class="flex" v-show="isLoginToPlay">
              <q-input
                v-model="loginToPlayDescription"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                type="textarea"
                :label="
                  isAARP
                    ? 'Login-Only Modal Description'
                    : 'loginToPlayDescription'
                "
              />
            </div>

            <div class="flex" v-show="isLoginToPlay">
              <q-input
                v-model="previewDateToShow"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                :label="isAARP ? 'Login-Only Modal Date' : 'previewDateToShow'"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-toggle
                v-model="earlyAccessMode"
                class="q-ml-lg q-mt-sm"
                :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                label="EarlyAccessMode"
              />
            </div>

            <div class="flex" v-show="!isAARP">
              <q-input
                v-model="goodsId"
                style="width: 90%"
                class="q-ml-md q-mt-sm"
                outlined
                label="GoodsId"
              />
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>

    <div class="q-mt-md q-mb-md">
      <q-btn
        v-if="!getPromoLoading && !isAARP && !selectedGame"
        label="Add Game"
        @click="createEventModal = true"
        color="positive"
        :disable="handlerDisableConfirm()"
      />
      <q-btn
        v-if="!getPromoLoading && selectedGame"
        label="Edit Game"
        @click="createEventModal = true"
        color="positive"
        :disable="handlerDisableConfirm()"
      />
      <q-btn
        v-if="!isAARP && !getPromoLoading && selectedGame"
        class="float-right"
        @click="deleteEventModal = true"
        color="negative"
      >
        <font-awesome-icon icon="fa-trash" size="sm" color="negative"
      /></q-btn>
    </div>

    <q-dialog v-model="createEventModal">
      <q-card class="card-modal q-ml-sm">
        <q-card-section>
          <h6 class="">
            {{ !selectedGame ? createModalText : editModalText }}
          </h6>
          <strong> {{ gameName.toUpperCase() }} </strong>
        </q-card-section>

        <q-card-actions class="flex justify-between q-ma-md">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn label="Confirm" color="positive" @click="confirmGameChange" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="deleteEventModal">
      <q-card class="card-modal">
        <q-card-section>
          <h6 class="q-ml-sm">{{ deleteModalText }}</h6>
          <strong class="q-ml-sm"> {{ gameName.toUpperCase() }} </strong>
        </q-card-section>

        <q-card-actions class="flex justify-between q-ma-md">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn label="Delete" color="primary" @click="deleteEventConfirm" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import { errorMessage } from "../errorMessages";

export default {
  name: "GameDescriptionView",

  data() {
    return {
      errorMessage,
      isAARP: null,

      headerMessage: "Game Description",
      modalText: "Confirm Game Changes",
      gamesListOptions: null,
      selectedGame: null,

      createEventModal: false,
      createModalText: "Are you sure you want to Create this Game?",
      editModalText: "Are you sure you want to Edit this Game?",
      deleteEventModal: false,
      deleteModalText: "Are you sure you want to DELETE the Event?",

      gameName: "",
      uRLAlias: "",
      finalURL: "",
      onPageTitle: "",
      promoDescription: "",
      onPageDescription: "",
      metaHTMLTitle: "",
      metaHTMLDescription: "",
      arena5Slug: "",
      theaterMode: false,
      isSchemaEnable: false,
      ogTitle: "",
      ogDescription: "",
      isInnerHtmlOnPageDescription: false,
      isFakeGame: false,
      preventGameEndOnSavedScore: false,
      isLoginToPlay: false,
      loginToPlayTitle: "",
      loginToPlayDescription: "",
      previewDateToShow: "",
      isHidden: false,
      isRewardInModal: false,
      isFriendGame: false,
      isSupportRewardVideo: false,
      isScreenshot: true,
      onPageTitleInnerHtml: "",
      isChallengeGame: false,
      hideLeaderboard: false,
      earlyAccessMode: false,
      devOnly: false,
      adUnitCustom: "",
      adUnitOverride: "",
      goodsId: "",
      canonicalTag: "",
      challengePoints: "",
      topPlayerScores: [],
      key: null,
    };
  },

  // Async mounted to wait for API requests
  async mounted() {
    if (this.getUser && this.getUser.idTokenClaims.roles.includes("Admin")) {
      this.isAARP = false;
    } else {
      this.isAARP = true;
    }
    await this.actionGetGamesSeo().then((response) => {
      this.gamesListOptions = _.orderBy(_.cloneDeep(response), ['GameName'], ['asc']);
    });
  },

  computed: {
    ...mapGetters({
      getGamesSeoList: "games/getGamesSeoList",
      getPromoLoading: "games/getPromoLoading",
    }),
    ...mapGetters({
      getEnv: "selectEnv/getEnv",
    }),
    ...mapGetters({
      getUser: "auth/getUser",
    }),
  },

  methods: {
    ...mapActions({
      actionGetGamesSeo: "games/actionGetGamesSeo",
      actionSetGameSEO: "games/actionSetGameSEO",
      actionDeleteGameSEO: "games/actionDeleteGameSEO",
    }),

    // Change Select and Json
    onSelectChange(val) {
      this.selectedGame = _.cloneDeep(val);
      if (val) {
        this.key = this.selectedGame.Key;
        this.gameName = this.selectedGame.GameName || "";
        this.uRLAlias = this.selectedGame.URLAlias || "";
        this.finalURL = this.selectedGame.FinalURL || "";
        this.onPageTitle = this.selectedGame.OnPageTitle || "";
        this.promoDescription = this.selectedGame.PromoDescription || "";
        this.onPageDescription = this.selectedGame.OnPageDescription || "";
        this.metaHTMLTitle = this.selectedGame.MetaHTMLTitle || "";
        this.metaHTMLDescription = this.selectedGame.MetaHTMLDescription || "";
        this.arena5Slug = this.selectedGame.Arena5Slug || "";
        this.theaterMode = this.selectedGame.TheaterMode || false;
        this.isSchemaEnable = this.selectedGame.IsSchemaEnable || false;
        this.ogTitle = this.selectedGame.OgTitle || "";
        this.ogDescription = this.selectedGame.OgDescription || "";
        this.isInnerHtmlOnPageDescription =
          this.selectedGame.IsInnerHtmlOnPageDescription || false;
        this.isFakeGame = this.selectedGame.IsFakeGame || false;
        this.preventGameEndOnSavedScore =
          this.selectedGame.PreventGameEndOnSavedScore || false;
        this.isLoginToPlay = this.selectedGame.IsLoginToPlay || false;
        this.loginToPlayTitle = this.selectedGame.LoginToPlayTitle || "";
        this.loginToPlayDescription =
          this.selectedGame.LoginToPlayDescription || "";
        this.previewDateToShow = this.selectedGame.PreviewDateToShow || "";
        this.isHidden = this.selectedGame.IsHidden || false;
        this.isRewardInModal = this.selectedGame.IsRewardInModal || false;
        this.isFriendGame = this.selectedGame.IsFriendGame || false;
        this.isSupportRewardVideo =
          this.selectedGame.IsSupportRewardVideo || false;
        this.isScreenshot =
          this.selectedGame.IsScreenshot === undefined
            ? true
            : this.selectedGame.IsScreenshot;
        this.onPageTitleInnerHtml =
          this.selectedGame.OnPageTitleInnerHtml || "";
        this.isChallengeGame =
          this.selectedGame.IsChallengeGame || false;
        this.hideLeaderboard =
          this.selectedGame.HideLeaderboard || false;
        this.earlyAccessMode =
          this.selectedGame.EarlyAccessMode || false;
        this.devOnly = this.selectedGame.devOnly || false;
        this.adUnitCustom = this.selectedGame.adUnitCustom || "";
        this.adUnitOverride = this.selectedGame.adUnitOverride || "";
        this.goodsId = this.selectedGame.GoodsId || "";
        this.canonicalTag =
          this.selectedGame.CanonicalTag ||
          this.selectedGame.canonicalTag ||
          "";
        this.challengePoints = this.selectedGame.ChallengePoints || "";
        this.topPlayerScores = this.selectedGame.topPlayerScores || [];
      } else {
        this.key = null;
        this.gameName = "";
        this.uRLAlias = "";
        this.finalURL = "";
        this.onPageTitle = "";
        this.promoDescription = "";
        this.onPageDescription = "";
        this.metaHTMLTitle = "";
        this.metaHTMLDescription = "";
        this.arena5Slug = "";
        this.theaterMode = false;
        this.isSchemaEnable = false;
        this.ogTitle = "";
        this.ogDescription = "";
        this.isInnerHtmlOnPageDescription = false;
        this.isFakeGame = false;
        this.preventGameEndOnSavedScore = false;
        this.isLoginToPlay = false;
        this.loginToPlayTitle = "";
        this.loginToPlayDescription = "";
        this.previewDateToShow = "";
        this.isHidden = false;
        this.isRewardInModal = false;
        this.isFriendGame = false;
        this.isSupportRewardVideo = false;
        this.isScreenshot = true;
        this.onPageTitleInnerHtml = "";
        this.isChallengeGame = false;
        this.hideLeaderboard = false;
        this.earlyAccessMode = false;
        this.devOnly = false;
        this.adUnitCustom = "";
        this.adUnitOverride = "";
        this.goodsId = "";
        this.canonicalTag = "";
        this.challengePoints = "";
        this.topPlayerScores = [];
      }
    },

    addOptionalField(game, fieldName, value) {
      const hasValue = Array.isArray(value)
        ? value.length > 0
        : value !== null && value !== undefined && value !== "";

      if (hasValue) {
        game[fieldName] = value;
      }
    },

    resetGameChange() {
      this.selectedGame = null;
    },

    handlerDisableConfirm() {
      if (this.isAARP) {
        if (this.isFakeGame) return this.finalURL === "";
        return (
          this.gameName === "" ||
          this.finalURL === "" ||
          this.onPageTitle === "" ||
          this.promoDescription === "" ||
          this.onPageDescription === "" ||
          this.metaHTMLTitle === "" ||
          this.metaHTMLDescription === "" ||
          this.ogTitle === "" ||
          this.ogDescription === ""
        );
      }
    },

    // Filter search game by names
    filterFn(val, update) {
      if (val === "") {
        update(() => {
          this.gamesListOptions = _.orderBy(_.cloneDeep(this.getGamesSeoList), ['GameName'], ['asc']);
        });
        return;
      }

       update(() => {
         const needle = val.toString().toLowerCase();
         this.gamesListOptions = _.orderBy(
           this.getGamesSeoList.filter(
             (game) =>
               game.GameName.toString().toLowerCase().indexOf(needle) > -1 ||
               game.Arena5Slug.toString().toLowerCase().indexOf(needle) > -1
           ),
           ['GameName'],
           ['asc']
         );
       });
    },

    // Async confirm to wait for the POST new games and the getGames on the return
    async confirmGameChange() {
      let gameObj = {
        GameName: this.gameName,
        URLAlias: this.uRLAlias,
        FinalURL: this.finalURL,
        OnPageTitle: this.onPageTitle,
        PromoDescription: this.promoDescription,
        OnPageDescription: this.onPageDescription,
        MetaHTMLTitle: this.metaHTMLTitle,
        MetaHTMLDescription: this.metaHTMLDescription,
        Arena5Slug: this.arena5Slug,
        TheaterMode: this.theaterMode,
        IsSchemaEnable: this.isSchemaEnable,
        OgTitle: this.ogTitle,
        OgDescription: this.ogDescription,
        IsInnerHtmlOnPageDescription: this.isInnerHtmlOnPageDescription,
        IsFakeGame: this.isFakeGame,
        PreventGameEndOnSavedScore: this.preventGameEndOnSavedScore,
        IsLoginToPlay: this.isLoginToPlay,
        LoginToPlayTitle: this.loginToPlayTitle,
        LoginToPlayDescription: this.loginToPlayDescription,
        PreviewDateToShow: this.previewDateToShow,
        IsHidden: this.isHidden,
        IsRewardInModal: this.isRewardInModal,
        IsFriendGame: this.isFriendGame,
        IsSupportRewardVideo: this.isSupportRewardVideo,
        IsScreenshot: this.isScreenshot,
        OnPageTitleInnerHtml: this.onPageTitleInnerHtml,
        IsChallengeGame: this.isChallengeGame,
        HideLeaderboard: this.hideLeaderboard,
        EarlyAccessMode: this.earlyAccessMode,
        devOnly: this.devOnly,
      };
      this.addOptionalField(gameObj, "adUnitCustom", this.adUnitCustom);
      this.addOptionalField(gameObj, "adUnitOverride", this.adUnitOverride);
      this.addOptionalField(gameObj, "GoodsId", this.goodsId);
      this.addOptionalField(gameObj, "CanonicalTag", this.canonicalTag);
      this.addOptionalField(
        gameObj,
        "ChallengePoints",
        this.challengePoints
      );
      this.addOptionalField(
        gameObj,
        "topPlayerScores",
        this.topPlayerScores
      );
      if (this.key) {
        gameObj = { ...gameObj, Key: this.key };
      }
      this.createEventModal = false;
      await this.actionSetGameSEO(gameObj)
        .then(async () => {
          await this.actionGetGamesSeo().then((response) => {
            this.gamesListOptions = _.cloneDeep(response);
          });
          this.onSelectChange("");
          this.$q.notify({
            type: "positive",
            message: `The game was successfully ${
              gameObj.Key ? "Edited" : "Created"
            }`,
          });
        })
        .catch((err) => {
          this.$q.notify({
            type: "negative",
            message: this.errorMessage(err.response.data.details[0].ErrorCode),
          });
        });
    },

    async deleteEventConfirm() {
      this.deleteEventModal = false;
      await this.actionDeleteGameSEO(this.key)
        .then(async () => {
          await this.actionGetGamesSeo().then((response) => {
            this.gamesListOptions = _.cloneDeep(response);
          });
          this.onSelectChange("");
          this.$q.notify({
            type: "positive",
            message: `The event was successfully Deleted`,
          });
        })
        .catch(() => {
          this.$q.notify({
            type: "negative",
            message: `An error occurred trying to Delete`,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-wrapper {
  min-height: 600px;
  position: relative;
  div {
    position: absolute;
    left: 50%;
    top: 10%;
  }
}

.game-content {
  max-width: 1140px;
}

.card-container {
  min-height: 60vh;
}

.card-modal {
  width: 600px;
  max-width: 80vw;
}
</style>
